customElements.define(
  "custom-style",
  class customStyle extends HTMLElement {
    constructor(params) {
      super();
      setTimeout(() => {
        let styleElement = document.createElement("style");
        styleElement.type = "text/css";
        styleElement.innerHTML = this.innerHTML;
        this.insertAdjacentElement("afterend", styleElement);
        this.remove();
      }, 1000);
    }
  }
);

document.querySelectorAll("[data-style]").forEach((element) => {
  let styles = element.dataset.style;
  element.removeAttribute("data-style");
  element.setAttribute("style", styles);
});

//Quantity Input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.input = this.querySelector("input");

    this.querySelectorAll("button")?.forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
    this.input?.addEventListener("blur", (e) => {
      this.input.dispatchEvent(this.changeEvent);
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = parseInt(this.input.value);

    event.target.name === "plus"
      ? (this.input.value = previousValue + 1)
      : (this.input.value = previousValue - 1);
    this.input.dispatchEvent(this.changeEvent);

    if (parseInt(this.input.value) === 1) {
      this.querySelector('button[name="minus"]').setAttribute(
        "disabled",
        "disabled"
      );
    } else if (
      parseInt(this.input.value) > 1 &&
      this.querySelector('button[name="minus"]').hasAttribute("disabled")
    ) {
      this.querySelector('button[name="minus"]').removeAttribute("disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

//CustomSelect
class CustomSelect {
  constructor(el) {
    this.el = el;
    this.select = el.querySelector("[data-selected-options]");
    this.dropdown = el.querySelector("[data-dropdown]");
    this.nativeSelect = el.querySelector("select");

    this.setListeners();
  }

  setListeners() {
    this.select?.addEventListener("click", (e) => this.onClick(e));
    this.dropdown
      .querySelectorAll("li")
      ?.forEach((el) => el?.addEventListener("click", (e) => this.onSelect(e)));

    document.addEventListener("click", (e) => {
      if (!this.select.contains(e.target)) {
        this.el.classList.remove("is-open");
      }
    });
  }

  onClick(e) {
    e.preventDefault();
    this.el.classList.toggle("is-open");
  }

  onSelect(e) {
    e.preventDefault();
    this.dropdown
      .querySelectorAll("li")
      .forEach((el) => el.classList.remove("vs__dropdown-option--selected"));
    e.target.closest("li").classList.add("vs__dropdown-option--selected");
    this.select.querySelector("span").innerText = e.target.innerText;
    this.el.classList.remove("is-open");

    if (this.nativeSelect) {
      const selectedValue = e.target.getAttribute("name");
      this.nativeSelect.value = selectedValue;

      const changeEvent = new Event("change", { bubbles: true });
      this.nativeSelect.dispatchEvent(changeEvent);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("div[data-custom-select]").forEach((el) => {
    new CustomSelect(el);
  });
});

//Accordion
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector("summary.accordion__header");
    this.content = el.querySelector(".accordion__content");
    this.showMoreButton = el.querySelector(".show-more__button");
    this.tease = el.querySelector(".show-more--tease");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.teaseIsOpen = false;

    this.summary?.addEventListener("click", (e) => this.onClick(e));
    if (this.showMoreButton && this.tease) {
      if (
        this.tease.querySelector(".scrolling-text__content")?.offsetHeight >=
        parseInt(
          this.tease.querySelector(".show-more__content").style.maxHeight
        )
      ) {
        this.showMoreButton.style.display = "block";
        this.tease.querySelector(".show-more__overlay").style.display = "block";
      }
      this.showMoreButton.addEventListener(
        "click",
        this.toggleAccordionTease.bind(this)
      );
    }
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: "ease-in",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight + 45
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: "ease-in",
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  toggleAccordionTease() {
    let maxHeight;

    this.teaseIsOpen = !this.teaseIsOpen;
    if (this.teaseIsOpen) {
      this.tease.classList.remove("show-more--collapsed");
      this.tease.classList.add("show-more--expanded");
      this.showMoreButton.querySelector("span").innerText = "Show Less";
      maxHeight = this.tease.querySelector(
        ".scrolling-text__content"
      )?.offsetHeight + 45;
    } else {
      this.tease.classList.add("show-more--collapsed");
      this.tease.classList.remove("show-more--expanded");
      this.showMoreButton.querySelector("span").innerText = "Show More";
      maxHeight = 314 - 45;
    }
    this.tease.querySelector(
      ".show-more__content"
    ).style.maxHeight = `${maxHeight + 45}px`;
    this.content.style.maxHeight = `${maxHeight + 45}px`;
    window.requestAnimationFrame(() => this.expand());
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";
  }
}

document.querySelectorAll("details.accordion").forEach((el) => {
  new Accordion(el);
});

//Variant selector
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();

    if (!this.currentVariant.available) {
      document.querySelector(".space-between").style.display = "none";
      document.querySelector(".product-form__atc").style.display = "none";
    } else {
      document.querySelector(".space-between").style.display = "block";
      document.querySelector(".product-form__atc").style.display = "block";
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery?.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent?.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );

    // Insert new media after title if there's a title
    const modalTitle = modalContent?.querySelector(".modal-title");
    if (modalTitle) {
      modalTitle.insertAdjacentElement("afterend", newMediaModal);
    } else {
      // Otherwise just add it to the top
      modalContent?.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, [data-product-form]`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  getSectionsToRender() {
    return [
      {
        selector: `#price-container`,
      },
      {
        selector: "#sku__value",
      },
      {
        selector: ".option-set__value",
      },
    ];
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.getSectionsToRender().forEach((section) => {
          const selector = section.selector;
          const destination = document.querySelectorAll(`${selector}`);
          const source = html.querySelectorAll(`${selector}`);

          if (source && destination) {
            destination.forEach((node) => {
              source.forEach((source) => {
                node.innerHTML = source.innerHTML;
              });
            });
          }
        });

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButtonEvent(disable = true, text, modifyClass = true, target) {
    const productForm = target.closest(".product-form__left");
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute("disabled");

      addButtonText.textContent =
        window.variantStrings.addToCart || "Add to Cart";
    }

    if (!modifyClass) return;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

//Toast
class ToastAlert extends HTMLElement {
  constructor() {
    super();
    this.messages = [];
    this.container = this.querySelector(".toast");
    this.timeout = 5000;
  }

  connectedCallback() {
    if (this.container) {
      this.container.classList.add("hidden");
    }
    this.addEventListener("toast/add", () => {
      if (this.messages.length > 0) {
        this.renderMessages();
      }
    });

    if (this.messages.length > 0) {
      this.renderMessages();
    }
  }

  addMessage(message) {
    const id = new Date().getTime();
    this.messages.push({ id, ...message });
    this.container = this.querySelector(".toast");
    this.dispatchEvent(new CustomEvent("toast/add"));
  }

  renderMessages() {
    if (this.container) {
      let elements = "";
      this.messages.forEach((message) => {
        elements += `
        <div class="toast__message ${message.type == "error" ? "error" : ""}">
        <p class="toast__message__copy">${message.text}</p>
        ${
          message.callback
            ? `<button class="button button--secondary small toast__message__cta" onclick="${message.callback}">
          ${message.label}
          </button>`
            : ""
        }
          </div>
          `;
      });
      this.container.innerHTML = elements;
      this.revealToast();
    }
  }

  revealToast() {
    this.container.classList.add("visible");
    setTimeout(() => {
      this.container.classList.remove("visible");
      this.messages = [];
      this.container.innerHTML = "";
    }, this.timeout);
  }
}

customElements.define("toast-alert", ToastAlert);

//Modal
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("click", (event) => {
        if (
          event.target.classList.contains("product-media-modal__content") ||
          event.target.classList.contains("product-media-modal")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    this.querySelectorAll("[data-modal-close")?.forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        this.hide();
      })
    );
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
